
import React from 'react'
import { FiTrash2, FiStar } from "react-icons/fi"

export const Skills = ({title, type, data, open }) =>{
    const [name,setName] = React.useState('')
    const [star,setStar] = React.useState(0)

    const [description,setDescription] = React.useState('')

    const getSkills = () => data?.filter((f)=>f.type===type) ||[]
 
    return (
        <React.Fragment>
            <br />
            {  <h3 className="">{title}</h3> }

            {open && (
                <div className="row">
                <div className="col-12">
                        <input type="text" name="name" placeholder="Example" value={name} onChange={e=>setName(e.target.value)} />
                    </div>
                    <div className="col-12">
                        <label htmlFor="">Description</label>
                        <textarea name="description" id="textarea1" placeholder="Job Skills" value={description} onChange={e=>setDescription(e.target.value)}></textarea>
                    </div>
                    <div className="col-6">
                        <div className="point"><label>Point:</label> <div className="stars">{Array.from(Array(5), (item, index)=><FiStar key={'s'+index}  className={`star ${index>=star && 'gray'}`} onClick={()=>{setStar(++index)}} />)}</div></div>
                        <small>Give a point.</small>
                    </div>
                    <div className="col-6">
                        <div className="">
                            <div className="float-right btn" >Add</div>
                        </div>
                    </div>
            </div>
            )}
            <div className="row">
                <div className="col-12">
                    <div className="personal_skills">
                        <ul>
                           {getSkills()?.length>0 && getSkills().map((skill,i)=>(
                                <li key={'skill'+i}>
                                    <div>
                                        <div className="staring">{Array.from(Array(5), (item, index)=><FiStar key={'star'+index} className={`star ${index>=skill.star && 'gray'}`}  />)}</div>
                                        <h4 className="title" title={skill.name}>{ type === 'personal' ? skill.name?.substring(0, 15) : skill.name?.substring(0, 9)}</h4>
                                        {skill?.description && (
                                            <small title={skill.description}>{ type === 'personal' ? skill.description?.substring(0, 15)  : skill.description?.substring(0, 25)+'...'}</small>
                                        )}
                                    </div>
                                    <div>
                                        <FiTrash2 />
                                    </div>
                                </li>
                           ))}
                        </ul>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}